import React from 'react'

import { Container } from './styles'

const Spinner: React.FC = () => (
    <Container></Container>
)


export default Spinner